import ReactDOM from 'react-dom';
import Button, { ButtonColor } from './button';
import { Spinner } from '@chakra-ui/react';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  header?: ReactNode;
  headerColor?: string;
  headerLeft?: boolean;
  modalState: boolean;
  loading?: boolean;
  submitText?: string;
  submitIcon?: string | ReactNode;
  submitColor?: ButtonColor;
  handleSubmit?: () => void;
  closeText?: string;
  closeIcon?: string | ReactNode;
  closeColor?: ButtonColor;
  handleCloseModal?: () => void;
  disableTransparent?: boolean;
  background?: string;
  buttonCenter?: boolean;
  disabled?: boolean;
  zIndex?: string;
  withIcon?: boolean;
  progress?: number | null;
};

export default function Modal({
  children,
  size,
  header,
  headerColor,
  headerLeft,
  modalState,
  loading,
  submitText,
  submitIcon,
  submitColor,
  handleSubmit,
  closeText,
  closeIcon,
  closeColor,
  handleCloseModal,
  disableTransparent,
  background,
  buttonCenter,
  disabled,
  zIndex,
  withIcon = true,
  progress = null,
}: Props) {
  const mappingSize = {
    xs: 'w-[300px]',
    sm: 'w-[500px]',
    md: 'w-[800px]',
    lg: 'w-[1000px]',
    xl: 'w-full',
  };

  const modalContent = (
    <>
      <input
        className="modal-state bg-asi-blue-primary"
        type="checkbox"
        checked={modalState}
        onChange={() => {}}
      />
      <div
        className={`modal max-w-[100vw] ${zIndex || 'z-[100]'} ${
          disableTransparent ? 'bg-gray-300' : ''
        } overflow-y-auto items-start p-4`}
      >
        <div
          className={
            `modal-content z-[100] max-w-full rounded-md shadow-md p-0 flex flex-col overflow-visible max-h-max font-montserrat ${background} ` +
            `${mappingSize[size]}`
          }
        >
          {header && (
            <div
              className={`${
                headerColor || 'z-50 bg-asi-blue-primary'
              } rounded-t-md font-semibold flex ${
                headerLeft ? 'justify-start' : 'justify-center'
              } py-3 px-4 text-xl text-white`}
            >
              {header}
            </div>
          )}
          <div className="px-4 py-3 z-50">
            {loading ? (
              <div className="flex flex-col justify-center items-center h-[300px]">
                <div className="spinner-dot-pulse">
                  <div className="spinner-pulse-dot"></div>
                </div>
                {progress !== null && (
                  <div className="text-center mt-4">
                    {progress != 0
                      ? `Uploading ${progress.toFixed(2)}%`
                      : 'Loading...'}
                  </div>
                )}
              </div>
            ) : (
              children
            )}
          </div>
          <div className="divider my-0 h-1"></div>
          <div
            className={`flex gap-x-2 ${
              buttonCenter ? 'justify-center' : 'justify-end'
            } p-3 -mt-2`}
          >
            <Button
              text={closeText || 'Close'}
              className="min-w-20"
              color={closeColor || 'error'}
              colorStyle="solid"
              onClick={() => handleCloseModal && handleCloseModal()}
              disabled={loading}
              withIcon={withIcon}
              icon={{
                pos: handleSubmit ? 'left' : 'right',
                icon: loading ? <Spinner size="sm" /> : closeIcon,
              }}
            />
            {handleSubmit && (
              <Button
                text={submitText || 'Submit'}
                className="min-w-20"
                colorStyle="solid"
                color={submitColor || 'primary'}
                onClick={
                  loading ? () => {} : () => handleSubmit && handleSubmit()
                }
                disabled={disabled}
                withIcon={withIcon}
                icon={{
                  pos: 'right',
                  icon: submitIcon,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );

  // return modalContent;
  return ReactDOM.createPortal(modalContent, document.body);
}
